import { connect } from "react-redux";
import { withRouter } from "react-router";
import Start from "./Start";
import { localeUpdateActions } from "Actions/localeActions";
import appActions from "Actions/appActions";
import userActions from 'Actions/userActions';

const mapStateToProps = (state, ownProps) => {
  let props = {
    markets: state.locale.markets,
    locale: state.locale,
    country: state.locale.country,
    language: state.locale.language,
    langOptions: state.locale.langOptions,
    isLoading: state.app.isLoading,
    //membershipID: state.user.data.id.unicity,
    // Optional chaining does not work here...
    membershipID: state.user.data ? state.user.data.id || null : null,
    termsConditionLink : state.locale.translations && state.locale.translations.terms_condition_link,
    termsCondition : state.locale.translations && state.locale.translations.account_terms_conditions,
    privacyPolicy : state.locale.translations && state.locale.translations.privacy_policy,
  };
  return props;
};

const mapDispatchToProps = (dispatch, location) => {
  return {
    updateLanguage: language => {
      dispatch(localeUpdateActions.updateLanguage(language));
    },
    updateCountry : countryCode => {
      dispatch(localeUpdateActions.updateCountry(countryCode));
    },
    updateCountryAndLanguage: (countryCode, languageCode) => {
      dispatch(localeUpdateActions.updateCountryAndLanguage(countryCode, languageCode));
    },
    dispatchSetCompletedStep: step => dispatch(appActions.setLastCompletedStep(step)),
    dispatchIsLoading: isLoading => dispatch(appActions.setIsLoading(isLoading)),
    
    dispatchSetUserData : userData => dispatch(userActions.setUserData(userData)),
    dispatchResetToken : () => {
      dispatch(userActions.setToken(null));
      let authStatus = false;
      dispatch(userActions.setAuthStatus(authStatus));
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Start));



// WEBPACK FOOTER //
// ./src/components/StartContainer/StartContainer.js